import { Col, Row, Typography } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useMemo, useState } from "react";
import {
  DevCardClass,
  DevCardObject,
} from "../../../classesAndInterfaces/DevCard";
import {
  reactCardDescription,
  reactTechnologiesAndTools,
} from "../../../textFiles/react";
import ReactCover from "../../../assets/react.png";
import NodeCover from "../../../assets/node.png";
import AWS_TechCover from "../../../assets/aws.png";
import DatabaseCover from "../../../assets/database.png";
import GISCover from "../../../assets/gis.png";
import DevCard from "../../../components/DevCard/DevCard";
import { awsCardDescription } from "../../../textFiles/aws";
import { nodeTechnologiesAndTools } from "../../../textFiles/node";
import {
  aws_techCardDescription,
  aws_techTechnologiesAndTools,
} from "../../../textFiles/aws-tech";

const { Title } = Typography;

const devCardArray: DevCardObject[] = [
  new DevCardClass({
    title: "React",
    description: reactCardDescription,
    image_url: ReactCover,
    techonologiesAndTools: reactTechnologiesAndTools,
  }),
  new DevCardClass({
    title: "Node",
    description: awsCardDescription,
    image_url: NodeCover,
    techonologiesAndTools: nodeTechnologiesAndTools,
  }),
  new DevCardClass({
    title: "Amazon Web Services",
    description: aws_techCardDescription,
    image_url: AWS_TechCover,
    techonologiesAndTools: aws_techTechnologiesAndTools,
  }),
  new DevCardClass({
    title: "Database",
    description: aws_techCardDescription,
    image_url: DatabaseCover,
    techonologiesAndTools: aws_techTechnologiesAndTools,
  }),
  new DevCardClass({
    title: "GIS",
    description: aws_techCardDescription,
    image_url: GISCover,
    techonologiesAndTools: aws_techTechnologiesAndTools,
  }),
];

const Technologies = () => {
  const [drawer, setDrawer] = useState(false);

  const breakpoints = useBreakpoint();

  const CardSpan = useMemo(() => {
    const screens = Object.entries(breakpoints).filter((screen) => !!screen[1]);
    const screen_size = screens[screens.length - 1]?.[0];
    switch (screen_size) {
      case "md":
        return 12; // 2 Cards per Row
      case "sm":
        return 24; // 1 Cards per Row
      case "xs":
        return 24; // 1 Cards per Row
      default:
        return 8; // 2 Cards per Row
    }
  }, [breakpoints]);

  const openDrawer = () => {
    setDrawer(true);
  };

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Row align={"middle"} justify={"center"} gutter={[24, 24]}>
          <Title level={2}>
            <a href="#technology-stack">Technology Stack</a>
          </Title>
        </Row>
      </Col>
      {devCardArray.map((card: DevCardObject, index: number) => {
        return (
          <Col span={CardSpan} key={index}>
            <DevCard
              title={card.title}
              description={card.description}
              image_url={card.image_url}
              techonologiesAndTools={card.techonologiesAndTools}
              openDrawer={openDrawer}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default Technologies;
